// @file Store for current user
import { getVuexStore } from '@@/bits/pinia'
import { UserRole } from '@@/bits/user_model'
import type { UserWithHashId } from '@@/types'
import type { RootState } from '@@/vuexstore/surface/types'
import { defineStore } from 'pinia'
import { computed } from 'vue'

export const useSurfaceCurrentUserStore = defineStore('surfaceCurrentUser', () => {
  const surfaceVuexStore = getVuexStore<RootState>()

  // Getters
  const currentUser = computed<UserWithHashId>(() => surfaceVuexStore?.getters.user as UserWithHashId)

  /**
   * Returns true if user has super admin privileges.
   * Replicates backend logic from services/rails/app/models/user.rb#with_native_superpowers?
   */
  const isSuperAdmin = computed(() => {
    const isNativeAdmin =
      currentUser.value.tenant_id === 1 && [UserRole.OWNER, UserRole.ADMIN].includes(currentUser.value.role)

    const emailDomain = currentUser.value.email?.split('@')[1]
    const hasWallwisherEmail = emailDomain === 'wallwisher.com'

    // Must be either native admin OR have wallwisher.com email (but not native)
    return isNativeAdmin || (hasWallwisherEmail && currentUser.value.tenant_id !== 1)
  })

  return {
    // Getters
    currentUser,
    isSuperAdmin,
  }
})
